export enum LOGO_MAINTENANCE_DISPLAY_TYPES {
  IDDLE = 'iddle',
  SCHEDULED_TODAY = 'scheduledToday',
  TIMER = 'timer',
  IMMINENT = 'imminent',
  IN_PROGRESS = 'inProgress',
  VERIFYING = 'verifying',
}
